import React, {
	useEffect
}from "react"
import {
	Form, DatePicker, Select
}from "antd"
import {
	useSelector, useDispatch
}from "react-redux"
import i18n from "./localization"
import "./style.css"
import CustomButton from "../../../components/ButtonCustom"
import localeRu from "antd/lib/date-picker/locale/ru_RU"
import localeBy from "antd/lib/date-picker/locale/by_BY"
import {
	CustomSelect
}from "../../../components/CustomSelect"
import {
	reInterimReasonActions
}from "../../nsi/ReInterimReasons/store/actions"

const ModalTempExternalAdminSetting = ({ setTempExternalAdmin, loading }) => {
	const [form] = Form.useForm()
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const reasons = useSelector((state) => state.reInterimReasonReducer.list)
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(reInterimReasonActions.getList())
		return () => {
			dispatch(reInterimReasonActions.clear())
		}
	}, [])

	return (
		<Form
			form={ form }
			labelAlign="left"
			labelCol={ { span: 4 } }
			layout="horizontal"
			name="form__interim__reason"
			onFinish={ (values) => setTempExternalAdmin(values) }
		>
			<Form.Item
				className="reason"
				label={ i18n.reason[isRu] }
				name="reInterimReasonId"
				rules={ [
					{ message  : i18n.isRequired[isRu],
						required : true }
				] }
			>
				<CustomSelect
					allowClear
					showSearch
					notFoundContent={ null }
					optionFilterProp="title"
					placeholder={ i18n.placeholderReason[isRu] }
				>
					{ reasons.map((value) => {
						return (
							<Select.Option
								key={ value.id }
								title={ isRu ? value.name : value.nameBel }
								value={ value.id }
							>
								{ isRu ? value.name : value.nameBel }
							</Select.Option>
						)
					}) }
				</CustomSelect>
			</Form.Item>
			<Form.Item
				className="date"
				label={ i18n.endDate[isRu] }
				name="dateTo"
				rules={ [
					{ message  : i18n.isRequired[isRu],
						required : true }
				] }
			>
				<DatePicker
					disabledDate={ (date) => !date || date.isBefore(new Date()) }
					form={ form }
					format="DD.MM.YYYY"
					locale={ isRu ? localeRu : localeBy }
				/>
			</Form.Item>
			<Form.Item className="save">
				<CustomButton
					htmlType="submit"
					loading={ loading }
					type="orange"
				>
					{ i18n.save[isRu] }
				</CustomButton>
			</Form.Item>
		</Form>
	)
}

export default ModalTempExternalAdminSetting
